

//components
import Code from './code';
import Result from './result';
import Header from './Header';

const Home = () => {
    return (
        <>
            <Header />
            <Code />
            <Result />
        </>
    )
}

export default Home;